import { useEffect } from "react";
import { CheckCircle, CalendarDays } from "lucide-react";
import { GHL_BOOKING_URL } from "@/lib/booking";
import type { LeadSubmissionResult } from "@/lib/leadSubmission";

export function LeadReceipt({ result, titleId }: { result: LeadSubmissionResult; titleId?: string }) {
  const stored = result.acceptedBy === "owned-intake";
  // The technical acceptance path (owned intake vs. email fallback, CRM sync
  // state) is real operational signal, but stating it to the visitor invites
  // a response-time expectation we can't promise. Keep it in the console for
  // support/debugging and show one honest, consistent line on the page.
  useEffect(() => {
    console.info("[lead-receipt] delivery status", {
      acceptedBy: result.acceptedBy,
      requestId: result.requestId,
      crmCreation: result.crmCreation,
    });
  }, [result]);
  return (
    <div role="status" className="text-center text-[#1D1D1F]">
      <CheckCircle size={40} className="text-[#24843e] mx-auto mb-3" />
      <h3 id={titleId} className="text-xl font-bold mb-2">{stored ? "Inquiry saved" : "Email service accepted your request"}</h3>
      <p className="text-sm text-[#6e6e73]">
        We have your message. A person reads every one. If you do not hear from us, call{" "}
        <a href="tel:+18136948671" className="underline">(813) 694-8671</a>.
      </p>
      <p className="mt-3 text-xs text-[#6e6e73] break-all">Reference: {result.requestId}</p>
      <a href={GHL_BOOKING_URL} target="_blank" rel="noopener noreferrer"
        className="mt-5 inline-flex items-center justify-center gap-2 rounded-lg bg-[#1D1D1F] px-4 py-3 text-sm font-bold text-white">
        Book a discovery call <CalendarDays size={15} />
      </a>
      <a href="mailto:chleb@chleb.ai" className="block mt-3 text-sm underline">Email chleb@chleb.ai</a>
    </div>
  );
}
